import React from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import {
  CapaQuotationPartnerStrategyFile,
  CapaQuotationPartnerTechnologyModel
} from '@generated/graphql';
import { DialogProps } from '@routes/CompanyInfo/types';
import DetailViewDialog from './DetailViewDialog';
import CertificateDetailInformation from './DetailViewInforamtion/CertificateDetailInformation';

interface CertificateDetailViewProps extends DialogProps {
  certificate: CapaQuotationPartnerTechnologyModel;
}

const CertificateDetailView: React.FunctionComponent<CertificateDetailViewProps> = ({
  open,
  onClose,
  certificate
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(900));

  return (
    <DetailViewDialog
      isOpen={open}
      onClose={onClose}
      maxWidth={!matches ? 1024 : undefined}
    >
      <DetailViewDialog.MediaSwiper
        backgroundColor="black"
        files={[certificate.file as CapaQuotationPartnerStrategyFile]}
      />
      <CertificateDetailInformation certificate={certificate} />
    </DetailViewDialog>
  );
};

export default CertificateDetailView;
